import axios from 'axios';
import {
    SUBMIT_MONTHLY_COLLECTION_REQUEST,
    SUBMIT_MONTHLY_COLLECTION_SUCCESS,
    SUBMIT_MONTHLY_COLLECTION_FAIL,
    GET_MY_MONTHLY_COLLECTIONS_REQUEST,
    GET_MY_MONTHLY_COLLECTIONS_SUCCESS,
    GET_MY_MONTHLY_COLLECTIONS_FAIL,
    GET_MY_MONTHLY_STATISTICS_REQUEST,
    GET_MY_MONTHLY_STATISTICS_SUCCESS,
    GET_MY_MONTHLY_STATISTICS_FAIL,
    UPDATE_MONTHLY_COLLECTION_REQUEST,
    UPDATE_MONTHLY_COLLECTION_SUCCESS,
    UPDATE_MONTHLY_COLLECTION_FAIL,
    DELETE_MONTHLY_COLLECTION_REQUEST,
    DELETE_MONTHLY_COLLECTION_SUCCESS,
    DELETE_MONTHLY_COLLECTION_FAIL
} from '../constants/monthlyCollectionConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const submitMonthlyCollection = (collectionData) => async (dispatch, getState) => {
    try {
        dispatch({ type: SUBMIT_MONTHLY_COLLECTION_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/monthlyCollection/submit`,
            collectionData,
            config
        );

        dispatch({
            type: SUBMIT_MONTHLY_COLLECTION_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: SUBMIT_MONTHLY_COLLECTION_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

export const getMyMonthlyCollections = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_MY_MONTHLY_COLLECTIONS_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/monthlyCollection/my-collections${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MY_MONTHLY_COLLECTIONS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MY_MONTHLY_COLLECTIONS_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

export const getMyMonthlyStatistics = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_MY_MONTHLY_STATISTICS_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/monthlyCollection/my-statistics${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MY_MONTHLY_STATISTICS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MY_MONTHLY_STATISTICS_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

export const updateMonthlyCollection = (id, collectionData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPDATE_MONTHLY_COLLECTION_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/monthlyCollection/update/${id}`,
            collectionData,
            config
        );

        dispatch({
            type: UPDATE_MONTHLY_COLLECTION_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: UPDATE_MONTHLY_COLLECTION_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

export const deleteMonthlyCollection = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: DELETE_MONTHLY_COLLECTION_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.delete(
            `${baseUrl}/monthlyCollection/delete/${id}`,
            config
        );

        dispatch({
            type: DELETE_MONTHLY_COLLECTION_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: DELETE_MONTHLY_COLLECTION_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};